// Which way an army faces, as a whole.
//
// A plurality vote over the side's pawns, because a re-aimed pawn or two
// should not turn the whole army round. Falls back to the side's forward
// facing, which is what a fresh army has before any of it has been aimed
// anywhere.
//
// Moved out of `src/client/ai/render/pieceViews.ts` on day 2 of the client
// split: it reads the whole board and `facingAt`, which is the rules' — and
// `BoardFacts.armyFacing` carries the answer, one per living side.

import {
  type Direction,
  DIRECTIONS,
  forwardFacing,
  PAWN,
  pieceColor,
  pieceType,
  type Side
} from "src/engine/rules/board";
import { facingAt, type Position } from "src/engine/rules/position";

export function armyFacing(pos: Position, side: Side): Direction {
  const votes = [0, 0, 0, 0];
  for (const [square, piece] of pos.board) {
    if (pieceColor(piece) !== side || pieceType(piece) !== PAWN) continue;
    votes[facingAt(pos, square)]++;
  }

  let best = -1;
  let winner = forwardFacing(side);
  // Ties break by direction order, which is fixed — two clients drawing the
  // same board have to agree, even about something purely cosmetic.
  for (const direction of DIRECTIONS) {
    if (votes[direction] > best) {
      best = votes[direction];
      winner = direction;
    }
  }
  return best > 0 ? winner : forwardFacing(side);
}
